'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPayAgreementsController = function () {
  function userPayAgreementsController(UsersService, NotificationService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, userPayAgreementsController);
    this.usersService = UsersService;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.isLoading = false;
  }

  (0, _createClass3.default)(userPayAgreementsController, [{
    key: '$onInit',
    value: function $onInit() {
      var ctr = this;
      this.confirmDeleteDialogOptions = {
        title: 'Confirm Delete',
        visible: false,
        closable: true,
        modal: true,
        buttonLayout: 'normal',
        messages: { close: '' },
        actions: [{ text: 'No' }, {
          text: 'Yes',
          primary: true,
          action: function action() {
            return ctr._doDelete();
          }
        }]
      };
      this.gridOptions = {
        dataSource: [],
        sortable: true,
        pageable: false,
        scrollable: false,
        resizable: true,
        noRecords: { template: 'No pay agreements found.' },
        columns: [{ field: 'payAgreementId', title: 'ID' }, { field: 'dateCreatedUtc', title: 'Date Created', template: '#= dateCreatedUtc ? kendo.toString(new Date(dateCreatedUtc), \'dd-MM-yyyy HH:mm\') : \'-\' #' }, { field: 'dateModifiedUtc', title: 'Date Modified', template: '#= dateModifiedUtc ? kendo.toString(new Date(dateModifiedUtc), \'dd-MM-yyyy HH:mm\') : \'-\' #' }, { field: 'isActive', title: 'Is Active', template: '#= isActive ? \'Yes\' : \'No\' #' }, { field: 'parentJugglerID', title: 'Parent Juggler ID' }, { field: 'payAgreementStatus', title: 'Status' }, { field: 'payPayer', title: 'Pay Payer' }, {
          title: 'Delete',
          width: '80px',
          command: [{
            text: ' ',
            iconClass: 'fa fa-trash',
            click: function click(e) {
              e.preventDefault();
              var tr = $(e.currentTarget).closest('tr');
              var dataItem = this.dataItem(tr);
              ctr._pendingDeleteId = dataItem.payAgreementId;
              ctr.confirmDeleteDialog.open();
            }
          }]
        }]
      };
      this._loadAgreements();
    }
  }, {
    key: '_doDelete',
    value: function _doDelete() {
      var _this = this;

      this.usersService.resetPayto(this.userId, this._pendingDeleteId, function () {
        _this.notificationService.success('Pay agreement deleted.');
        _this._loadAgreements();
      }, function () {
        return _this.notificationService.error('Failed to delete pay agreement.');
      });
    }
  }, {
    key: '_loadAgreements',
    value: function _loadAgreements() {
      var _this2 = this;

      this.isLoading = true;
      this.usersService.getPayAgreements(this.userId, function (response) {
        _this2.isLoading = false;
        var grid = $('#pay-agreements-grid').data('kendoGrid');
        if (grid) {
          grid.setDataSource(new kendo.data.DataSource({ data: response.data }));
        }
        _this2.$scope.$apply();
      }, function () {
        _this2.isLoading = false;
        _this2.notificationService.error('Failed to load pay agreements.');
        _this2.$scope.$apply();
      });
    }
  }]);
  return userPayAgreementsController;
}();

exports.default = userPayAgreementsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-pay-agreements/user-pay-agreements.controller.js
 **/